// Remove all console methods in production builds
export const removeConsoleLogs = () => {
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
    // Keep console.error for critical errors that should be caught by error tracking
  }
};

